import * as images from "@/components/images/Images";
import { AboutUsHumanConnectionData } from "./types";

export const aboutUsHumanConnectionData: AboutUsHumanConnectionData = {
  card: {
    title: "Human connection",
    description:
      "We believe language is more than words—it’s what connects us. And although we’re a modern online platform, we are still humans helping humans create meaningful connections. We are committed to being a people-first business and consider how we contribute to the human experience not only in perspective, but action.",
    imageUrl: images.aboutUsHumanConnection,
  },
  items: [
    {
      iconId: "icon-centered_64",
      title: "People centered",
      description:
        "Our team and clients are at the heart of everything we do. We believe in creating amazing experiences and in building lasting relationships through continuous feedback and improvement. We thrive on making sure our clients and team feel respected, empowered, and valued.",
    },
    {
      iconId: "icon-star_64",
      title: "Lead with integrity",
      description:
        "We do what’s right, always. Languex is committed to being an honest and reliable partner. We set clear expectations, practice proactive communication, and take responsibility, ensuring clients can always trust us to deliver on our promises.",
    },
    {
      iconId: "icon-talk_64",
      title: "Proactive response",
      description:
        "We’re committed to delivering the highest human-quality as quickly as humanly possible. We understand that timeliness is critical, so we respond quickly to inquires, adapt to shifting needs, and prioritize agility in operations. We strive to ensure our service delivery is always aligned with your expectations.",
    },
  ],
} as const;
